export enum CircumstancesType {
  NEURODIVERSITY = "Neurodiversity",
  MENTAL_HEALTH = "Mental health",
  WELLBEING = "Wellbeing",
  DISABILITY = "Disability",
}

export enum NeuroDetailsType {
  AUTISM = "Autism",
  ADHD = "ADHD",
  DYSLEXIA = "Dyslexia",
  DYSCALCULIA = "Dyscalculia",
  OTHER = "Other",
}
